import React, { useEffect, useRef, useState } from 'react';
import classes from './Toolbar.css';
import HeaderItems from '../HeaderItems/HeaderItems';
import Wrapper from '../../../hoc/Wrap/Wrap';
import MenuBar from '../MenuBar/MenuBar';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions/index';
import { 
    SESSION_SUPERUSER, 
    SESSION_TIER1USER, 
    SESSION_READONLYUSER, 
    SESSION_USERTYPE, 
    SESSION_SUPERVISORUSER, 
    SESSION_BASELINEAGENT, 
    SESSION_USERNAME
} from "../../../shared/Constants";
import Input from '../../../UI/Input/Input';
import HSIDLogo from '../../../components/Logo/HSIDLogo';
import { isPrivilegedUser } from '../../../shared/utility';

const userTypes = [
    SESSION_TIER1USER, 
    SESSION_SUPERUSER, 
    SESSION_READONLYUSER, 
    SESSION_SUPERVISORUSER, 
    SESSION_BASELINEAGENT
];

const featureRoles = [
    "supervisor",
    "tier1"
]

const selectConfig = {
    type: 'text',
    id: 'userType',
    placeholder: '',
    options: userTypes.map(userType => ({
        "disabled": false,
        "value": userType,
        "displayValue": userType
        })
    )
}

const featureSelectConfig = {
    type: 'text',
    id: 'userFeature',
    placeholder: '',
    options: [{
        "disabled": false,
        "value": "Yes",
        "displayValue": "Yes"
    },{
        "disabled": false,
        "value": "No",
        "displayValue": "No"
    }]
}

const toolbar = (props) => {

    let menuBar = props.user.loggedIn?<MenuBar disableUser = {props.user.disableUser} userType = {props.user.userType}/>:null;
    let browVerDomElem = document.getElementById('buorg');
    let upgradeBrowser = browVerDomElem !== 'undefined' ? true : false;
    const [defaultFeatureRole, setDefaultFeatureRole] = useState(props.user?.featureTestRole ?? "")
    const [featureAccess, setFeatureAccess] = useState("No");
    const isExplicitFeatureAccessChange = useRef(false);
    const userDisplay = {[SESSION_READONLYUSER]:'Read-Only', [SESSION_SUPERUSER]:'Super User', [SESSION_TIER1USER]:'Tier 1', [SESSION_SUPERVISORUSER]:'Supervisor', [SESSION_BASELINEAGENT]:'BaselineAgent'};

    const onUserTypeSelect = (event) => {
        props.checkAgentAccessSuccess(event.target.value, props.user.agentEmailId, props.user.featureTestRole, props.user?.features);
        localStorage.setItem(SESSION_USERTYPE, event.target.value)
    }
    const onFeatureSelect = (event) => {
        const selectedFeatureAccess = event.target.value;
        isExplicitFeatureAccessChange.current = true;
        setFeatureAccess(selectedFeatureAccess);
        props.checkAgentAccessSuccess(props.user.userType, props.user.agentEmailId, selectedFeatureAccess === "Yes" ? defaultFeatureRole : "", props.user?.features);
    }
    useEffect(()=>{
        if(props.user?.featureTestRole) {
            setDefaultFeatureRole(props.user?.featureTestRole)
        }
        if (isExplicitFeatureAccessChange.current) {
            isExplicitFeatureAccessChange.current = false;
            return;
        }
        setFeatureAccess("No");
    },[props.user?.featureTestRole])
    // for development and testing purpose enabling specific users functionality to swtich between superuser and teir 1 user
    const superUserToggleSwitch = isPrivilegedUser(localStorage.getItem(SESSION_USERNAME), process.env.NODE_ENV) ?
            <nav className={classes.ToggleSwitch}>
                    <Input 
                        key="superUser"
                        value={props.user.userType}
                        label={"Using like a"}
                        disabled={false}
                        inputType={"Half"}
                        elementType={"select"}
                        elementConfig={selectConfig}
                        changed={onUserTypeSelect}
                    />
                    {defaultFeatureRole && <Input 
                        key="superUser"
                        value={featureAccess}
                        label={"Access features"}
                        disabled={false}
                        inputType={"Half"}
                        elementType={"select"}
                        elementConfig={featureSelectConfig}
                        changed={onFeatureSelect}
                    />}
                </nav> : null;

    return (
        <Wrapper>
            <header className={upgradeBrowser ? classes.ToolbarBrowserVersion : classes.Toolbar}>
                <div>
                    <h1>{props.appName} ({userDisplay[props.user.userType]})</h1>
                </div>
                {superUserToggleSwitch}
                <HSIDLogo />
                <div style={{marginLeft : "3.5%"}}><nav>
                    <HeaderItems
                        displayName={props.user.displayName}
                        logoutHandler={props.onUserLogout}
                    />
                </nav></div>
            </header>
            <div className={upgradeBrowser ? classes.DividerBrowserVersion : classes.Divider}>
            </div>
            {menuBar}
        </Wrapper>
    );
}

const mapStateToProps = state => {
    return {
        user: state.usr.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        checkAgentAccessSuccess: (userType, agentEmailId, featureTestRole, features) => dispatch(actions.checkAgentAccessSuccess(userType, agentEmailId, featureTestRole, features)),
        onUserLogout: () => dispatch(actions.logoutUser())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(toolbar);